import variables from "../../mixins.scss";

const selectStyle = {
    container: (provided) => ({
      ...provided,
      width: "100%",
      maxWidth: 300,
      textAlign: "left",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: `#5d5d5d`,
      fontWeight: "600",
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: 2,
      padding: "3px 0",
      border: "none",
      boxShadow: "unset",
      borderBottom: `1px solid #7d7d7d`,
      height: 50,
      "&:hover": {
        borderBottom: `1px solid #5d5d5d`,
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: 2,
      maxHeight: 200,
      zIndex: 5,
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 200,
    }),
  };

export const distributorSelectStyle = {
    ...selectStyle,
    container: (provided) => ({
      ...provided,
      width: "100%",
      textAlign: "left",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: `${variables.blueVioletColor}`,
      font: `700 normal 0.75rem/150% ${variables.defaultFont}`,
      opacity: 0.4,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0 0 7px 7px",
      border: `1px solid ${variables.outlineColor}`,
      borderTop: "none",
      boxShadow: "none",
      padding: "0 14px 8px 8px",
      margin: 0,
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: "7px",
      boxShadow: "none",
      border: `1px solid ${variables.outlineColor}`,
      padding: "3px 0 3px 8px",
      height: 50,
      "&:hover": {
        border: `1px solid ${variables.outlineColor}`,
      },
    }),
  };
  